import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { initialize } from '../../features/ui/redux/uiSlices';

/** Hook for fetching initial app data */
export const useAppAjaxInit = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(initialize());
    }, [dispatch]);
};
